const DATE_FORMATS = {
  standard: 'MMM DD, YYYY',
  iso: 'YYYY-MM-DD',
  tick: 'MM/DD/YY',
  timestamp: 'MMM DD, YYYY h:mm A',
  delivery: 'YYYYMMDD'
};

export default DATE_FORMATS;
